import type { NormalizedInterval } from 'date-fns'
import { isEmpty } from '@ember/utils'
import fillMonths from 'district-ui-client/utils/student-events/fill-months'
import type { StatsScope } from 'district-ui-client/utils/student-events/stats-scope'
import type StudentEventsService from 'district-ui-client/services/student-events'

export interface CourseProgressAveragesResponse {
  course_progress_averages_by_grade_by_month: {
    grade_position: number
    months: {
      month: string
      avg_max_lesson: number
    }[]
  }[]
}

export interface CourseProgressAveragesData {
  grade_position: number
  months: {
    month: string
    avg_max_lesson: Nullable<number>
  }[]
}

export async function courseProgressAverages(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex | LegacyProductMs,
  precinct: LegacyPrecinctLessons | LegacyPrecinctReading | LegacyPrecinctSpelling | LegacyPrecinctMyLessons,
  statsScope: StatsScope,
  period: NormalizedInterval,
): Promise<Nullable<CourseProgressAveragesData[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('course_progress_averages_by_grade_by_month', product, statsScope)
  const query = this.buildQuery(statsScope, period, { precinct })

  const data = await this.fetchData<CourseProgressAveragesResponse>(url, query)
  if (!data) return null

  const { course_progress_averages_by_grade_by_month: course_progress_averages } = data
  if (course_progress_averages.length === 0) return null

  const sortedAverages = [...course_progress_averages].sort((a, b) => a.grade_position - b.grade_position)

  return sortedAverages.map((average) => {
    return {
      grade_position: average.grade_position,
      months: fillMonths(average.months, period, { avg_max_lesson: null }),
    }
  })
}
